/* eslint-disable */
import { Grid, Typography } from "@rentacenter/racstrap";
import { ExcelPreviewStyles } from "../Styles/ExcelPreview";

interface ExcelPreviewTabsProps {
  sheetNames: string[];
  activeIndex: number;
  onTabChange: (index: number) => void;
}

export default function ExcelPreviewTabs({
  sheetNames,
  activeIndex,
  onTabChange,
}: ExcelPreviewTabsProps) {
  const classes = ExcelPreviewStyles();

  return (
    <Grid container direction="row" alignItems="center">
      {sheetNames.map((name, index) => (
        <Grid item key={index}>
          <Typography
            className={
              index === activeIndex
                ? classes.sheetTabActive
                : classes.sheetTabInactive
            }
            onClick={() => onTabChange(index)}
          >
            {name}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
}
